import axios from "axios"
import { BASE_URL } from "@/constants"
import store from "@/store"

function createApi(apiVersion) {
  const api = axios.create({ baseURL: `${BASE_URL}api/${apiVersion}/` })

  api.interceptors.request.use(config => {
    config.headers["Authorization"] = `Token ${store.state.User.token}`
    config.maxBodyLength = Infinity
    config.maxContentLength = Infinity
    return config
  })

  api.interceptors.response.use(
    response => response,
    error => {
      error.config.retryCount = error.config.retryCount || 0
      // This is meant to retry on "instant" 504s from the AWS load balancer
      // The "Network Error" check is a hack because the load balancer doesn't provide CORS headers
      // and the browser doesn't send anything about the response here in that case
      if (
        (error.message == "Network Error"
          || (error.response && error.response.status === 504))
        && error.config.retryCount < 2
      ) {
        error.config.retryCount += 1
        return api.request(error.config)
      }
      return Promise.reject(error)
    }
  )

  return api
}

export default createApi("v1")

// Add the v2 API
export const APIv2 = createApi("v2")
